var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messageVisiable)?_c('div',{staticClass:"v-message",style:(("background:" + _vm.color))},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }